import { Box } from "@mui/material";
import MetaTags from "react-meta-tags";

import { Announcement } from "components/header/components/Announcement";
import { MoreQuestions } from "components/MoreQuestions";
import {
  SITE_TITLE,
  SITE_META_DESCR,
  SITE_LINK_CANONICAL,
} from "helpers/metatags";

import {
  GenericBanner,
  KeyFeatures,
  NextGeneration,
  TopBanner,
  WorkflowSteps,
} from "./components";

export const Homepage = () => {
  return (
    <Box component="article" width={1}>
      <MetaTags>
        <title>{SITE_TITLE}</title>
        <meta content={SITE_META_DESCR} name="description" />
        <link rel="canonical" href={SITE_LINK_CANONICAL} />
      </MetaTags>

      <Announcement />
      <TopBanner />
      <NextGeneration />
      <GenericBanner />
      <KeyFeatures />
      <WorkflowSteps />
      <MoreQuestions />
    </Box>
  );
};
